var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.scrollDisabled
    ? _c(
        "div",
        { staticClass: "o-grid" },
        [
          _vm.heading
            ? _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12" }
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "c-teaser-gallery__heading text-h2 heading-boarder t-margin--0-top"
                    },
                    [_vm._v("\n\t\t\t" + _vm._s(_vm.heading) + "\n\t\t")]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.images, function(image, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "o-grid__column o-grid__column--heightauto c-teaser-gallery__group",
                attrs: { "data-size": "sm:12 md:4 lg:4" }
              },
              [
                _c("v-object-development", {
                  attrs: { image: image, readMoreLabel: _vm.readMoreLabel }
                })
              ],
              1
            )
          })
        ],
        2
      )
    : _c("div", { staticClass: "o-grid " }, [
        _vm.heading
          ? _c(
              "div",
              {
                staticClass: "o-grid__column",
                attrs: { "data-size": "sm:12" }
              },
              [
                _vm.heading
                  ? _c(
                      "h2",
                      {
                        staticClass:
                          "c-teaser-gallery__heading text-h2 heading-boarder t-margin--0-top"
                      },
                      [_vm._v("\n\t\t\t" + _vm._s(_vm.heading) + "\n\t\t")]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "o-grid__column t-padding--0-right t-padding--0-left",
            attrs: { "data-size": "sm:12 md:12 lg:12" }
          },
          [
            _c(
              "div",
              {
                class:
                  "c-teaser-gallery " + (_vm.heading ? "" : "t-margin--1-top")
              },
              [
                _c("v-gallery-image-scroller", {
                  attrs: {
                    "is-links": _vm.isLinks,
                    hasTextBelow: _vm.hasTextBelow,
                    readMoreLabel: _vm.readMoreLabel,
                    images: _vm.images,
                    "thumbnail-width": _vm.thumbnailWidth,
                    "step-length": _vm.stepLength,
                    headingLevel: _vm.heading ? "h3" : "h2"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "intro",
                        fn: function() {
                          return [_vm._t("intro")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _vm.link && _vm.linkText
                  ? _c("div", { staticClass: "c-teaser-gallery__button" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "c-button c-button--highlight c-button--icon",
                          attrs: { href: _vm.link }
                        },
                        [
                          _c("span", { staticClass: "c-button--right" }, [
                            _vm._v(_vm._s(_vm.linkText))
                          ]),
                          _vm._v(" "),
                          _c("v-icon", {
                            attrs: { name: "icon-chevron", size: "xxs" }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }